<template>
  <div class="wnds_join">
    <div class="wj_banner">
      <img src="../../../static/img/join_banner.56371ec.png" alt="">
    </div>

    <div class="bgImg">
      <img src="../../../static/img/whlc_bg_icon.png" alt="">
    </div>
    <div class="introduce">
      <p>我们在做一件关注人们精神与审美的事。</p>
      <p>每一位走向我们的人，都希望让生活变得更有诗意、更有意义。</p>
      <p>加入「为你读诗」，也许就是诗意生活的一种开始。</p>
      <p>在这里，你可以与许多同伴一起，唤醒人们的感受、触及人们的心灵。</p>
      <p>与我们一起，让诗意发生。</p>
    </div>
    <div class="wj_occupation">
      <ul class="wjc_btnlist tcf-flex tcf-justify-center">
        <li :class="flag ? 'active': 'original'" @click="checkAll" id="all">全部</li>
        <li v-for="(item,index) in classifylist" :key="index" :itemindex="item.id" :class="checkChild ? 'active': 'original'" @click='classify(item.id,index)' id='other'>{{item.str_post_name}}</li>
      </ul>
      <ul class="wjc_occlist tcf-flex tcf-justify-justify">
        <li>职位</li>
        <li>类别</li>
        <li>工作部门</li>
        <li>工作地点</li>
      </ul>
      <div class="wjc_occlist_det">
        <el-collapse accordion>
          <el-collapse-item class="wjcod_content" v-for="(item, index) in ifylist" :itemindex="index" :key="item.id">
            <template slot="title">
              <div class="wjcod_content_title tcf-flex tcf-justify-justify">
                <p>{{item.str_post_name}}</p>
                <p>{{item.str_classify_name}}</p>
                <p>{{item.str_department_name}}</p>
                <p>{{item.str_adress_info}}</p>
              </div>
            </template>
            <div class="wjcod_content_detail">
              <div v-html="item.str_post_detial"></div>
              <hr class="wjcod_content_line">
              <p>岗位投递（注明期待薪资及应聘岗位） 请发简历到邮箱：hr@bemyguest.com.cn</p>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="wj_cpshowbox">
      <ul class="wjc_show tcf-flex tcf-justify-justify">
        <li>
          <img src="../../../static/img/images/images/joinus.png" alt="" style="width:564px;height:186px;">
          <img src="../../../static/img/join_pic_02.e595c45.png" alt="" style="width:564px;height:320px;">
        </li>
        <li>
          <img style="margin-bottom: 19px;width:564px;height:320px;margin-left:20px;" src="../../../static/img/图片 6.png" alt="">
          <img src="../../../static/img/images/images/joinus44_03.png" alt="" style="width:564px;height:186px;margin-left:20px;">
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "join",
  data(){
		return{
      classifylist: [],
      ifylist: [],
      select:'',
      categoryIndex:0,
      flag:true,
      checkChild: false
		}
  },
  created(){
    this.$parent.activeIndex = 'join'
		this.axios.post(
      process.env.API_HOST + '/postclassifylist',
      this.$qs.stringify({"page": 1, "per": 10, "str": ""})
    )
    .then(res => {
      this.classifylist = res.data.msg.rows;
    })
    .catch(error => {
      console.log(error);
      this.$toast("网络错误，不能访问");
    })
    this.getifylistFn(1,10,"",this.select)
  },
  methods:{
    getifylistFn( page, per, str, classifyid ){
      this.axios.post(
				process.env.API_HOST + '/postlist',
				this.$qs.stringify({"page": page, "per": per, "str": str, "n_classify_id": classifyid})
			)
			.then(res => {
				this.ifylist = res.data.msg.rows
			})
			.catch(error => {
				this.$toast("网络错误，不能访问");
			})
    },
    classify(id,index){
      this.select = id;
      this.getifylistFn (1,10,"",this.select);
      this.categoryIndex = index;
      this.flag = false;
      this.classifylist.forEach((v,index) => {
        if(v.id === id) {
          $('#all').nextAll()[index].className = 'active'
        } else {
          $('#all').nextAll()[index].className = 'original'
        }
      })
    },
    // 选择全部
    checkAll () {
      this.getifylistFn (1,10,"",'')
      this.flag = true
      this.checkChild = false
      this.classifylist.forEach((v,index) => {
          $('#all').nextAll()[index].className = 'original'
      })
    },

  }
}
</script>
<style>
.wjcod_content .el-collapse-item__header {
  height: 70px;
  line-height: 70px;
  color: #404040;
  position: relative;
}
.wjcod_content .el-collapse-item__header {
  height: 70px;
  line-height: 70px;
  color: #404040;
  position: relative;
}
.wjcod_content .el-collapse-item__arrow {
  font-size: 18px;
  line-height: 70px;
  color: #404040;
  position: absolute;
  top: 0;
  left: 30px;
}
.el-collapse-item__header:hover .el-collapse-item__arrow{
  color: #fff;
}
</style>

<style scoped>
.wnds_join{
  display: inline-table;
  width: 100%;
  background: #fff;
}
.active {
 color:#8ca764 !important;
}
.original{
  color: #404040;
}
.wj_banner, .wj_banner img {
  width: 100%;
  font-size: 0;
}
.wj_contentbox {
  width: 100%;
  background-color: #f8f8f8;
}
.wj_content {
  width: 1140px;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 30px;
}
.wjc_title {
  display: block;
  margin: 0 auto;
  margin-bottom: 86px;
}
.wjc_content {
  width: 1140px;
  margin: 0 auto;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.bgImg{
  text-align: center;
  margin-top: 80px;
}
.introduce{
  text-align: center;
  margin-top: 80px;
  line-height: 50px;
  font-size: 20px;
  color: #727272;
}
.wjcc_slider {
  width: 495px;
  height: 413px;
  text-align: center;
}
.wjcc_slider p:nth-child(2){
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 22px;
  line-height: 22px;
  color: #8ca764;
}
.wjcc_slider p:nth-child(3){
  font-size: 14px;
  line-height: 24px;
  color: #6d6d6d;
  text-align: justify;
}
/* *** */
.wj_occupation {
  width: 1140px;
  margin: 0 auto;
  padding-top: 100px;
}

.wjc_btnlist li {
  cursor: pointer;
  padding: 0 50px;
  line-height: 22px;
  font-size: 22px;
  color: #404040;
  border-right: 1px solid #313131;
}
.wjc_btnlist li:last-child{
  border: 0;
}
.wjc_btnlist li.btnavctive{
  color: #8ca764;
}
.wjc_occlist {
  margin-top: 76px;
  color: #848484;
  border: 1px solid #bfbfbf;
}
.wjc_occlist li {
  width: 20%;
  height: 68px;
  text-align: center;
  font-size: 18px;
  line-height: 68px;
}
.wjc_occlist_det {
  margin-bottom: 165px;
  border: 1px solid #bfbfbf;
  border-top: 0;
}
.wjcod_content_title,.el-collapse-item__header {
  height: 70px;
  line-height: 70px;
  color: #404040;
}
.wjcod_content_title {
 width: 100%;
}
.wjcod_content_title p{
  width: 20%;
  text-align: center;
  font-size: 18px;
}
.wjcod_content_title:hover{
  background-color: #b7ca9b;
  color: #fff;
}
.wjcod_content li:nth-child(1):hover{
  background-color: #b7ca9b;
  color: #fff;
}
.wjcod_content_btn {
  font-size: 18px;
  position: absolute;
  top: 26px;
  left: 30px;
}
.wjcod_content_detail {
  margin: 0 20px;
  padding: 35px 40px 20px 40px;
  color: #404040;
  background-color: #f8f8f8;
}
.wjcod_content_line {
  border-bottom: 1px dashed #b5b5b5;
  margin-top: 16px;
  margin-bottom: 16px;
}
/* *** */
.wj_cpshowbox {
  width: 1140px;
  margin: 0 auto;
  font-size: 0;
  padding-bottom: 140px;
}
.wjc_show img {
  display: block;
}
.wjc_show li img:nth-child(1){
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Join.vue